module.exports = __webpack_public_path__ + "static/06-45211e603bb8d11db4d014a627810ab7.jpg";